const Vue = require('./Vue').default;
const Store = require('./Store').default;

class App {
  constructor(vue, store) {
    this.vue = vue;
    this.store = store;
  }

  /**
   * I can't change name for this functions because of
   * back end and their foundation core module
   */

  setStores(results) {
    this.store.setResultsStores(results);
  }

  setStoreModules(modules) {
    this.store.setStores(modules);
  }
}

export default new App(new Vue(), new Store());
